import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex lg:flex-wrap lg:flex-row flex-col lg:items-center min-h-screen lg:justify-between" }
const _hoisted_2 = { class: "w-full px-4 lg:w-1/2 sm:px-20 lg:py-0 py-6" }
const _hoisted_3 = { class: "sm:max-w-[360px] mx-auto" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "mb-6" }
const _hoisted_6 = { href: "/reset-pin" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mt-6 text-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/login",
    class: "text-sm m-0 text-primary-600 hover:text-primary-800 transition"
  }, "Return to Login")
], -1)

import {
    IonPage,
    IonContent 
} from '@ionic/vue';
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import TextInput from '@/components/inputs/TextInput.vue';

import AuthLogo from "../Components/AuthLogo.vue";
import AuthTitle from "../Components/AuthTitle.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPin',
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(AuthLogo),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(AuthTitle, {
                  title: "Forgot Pin",
                  description: "Kindly provide your email address"
                }),
                _createElementVNode("form", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(TextInput, {
                      type: "email",
                      label: "Email Address",
                      placeholder: "Email Address",
                      name: "email",
                      id: "email"
                    })
                  ]),
                  _createElementVNode("a", _hoisted_6, [
                    _createVNode(ButtonComponent, {
                      type: "submit",
                      size: "large",
                      btnWidth: "w-full rounded-lg"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Submit ")
                      ]),
                      _: 1
                    })
                  ]),
                  _hoisted_7
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})